import {Injectable} from '@angular/core';


declare let _: any;

@Injectable({
  providedIn: 'root'
})
export class CollaborationCacheService{
  cacheMap: any = new Map();
  storeMap: Map<string, any> = new Map();

  initCache(){
    if (!this.cacheMap){
      this.cacheMap = new Map();
    }
    if (!this.storeMap){
      this.storeMap = new Map();
    }
  }

  insertCache(companyId, data, postType){
    let cachePostObj = {};
    if (postType === 'all') {
      cachePostObj = {
        [postType] : data,
        external : [],
        internal: []
      };
    } else if (postType === 'internal') {
      cachePostObj = {
        [postType] : data,
        external : [],
        all: []
      };
    } else if (postType === 'external'){
      cachePostObj = {
        [postType] : data,
        internal : [],
        all: []
      };
    }
    if (this.cacheMap.size == 0){
      this.cacheMap.set(companyId, cachePostObj);
    }else {
      const cacheData = this.cacheMap.get(companyId);
      if (!cacheData){
        this.cacheMap.set(companyId, cachePostObj);
      } else if (cacheData) {
        cacheData[postType] = data;
        this.cacheMap.set(companyId, cacheData);
      }
    }
  }

  getCacheData(companyId, postType){
    const cacheData = this.cacheMap.get(companyId);
    if (cacheData) {
      return cacheData[postType];
    }
    return null;
  }

  updateCacheData(companyId, latestData){
    const data = this.cacheMap.get(companyId);
    if (data && data[latestData.data.post_type] && (data[latestData.data.post_type].length > 0 || data.all.length > 0)){
      const oldPost = _.remove(data[latestData.data.post_type], {id: latestData.data.id});
      if (oldPost && oldPost.length > 0 && oldPost[0].tags && oldPost[0].tags.includes('Unread')){
        const unreadIndex = latestData.data.tags.indexOf('Unread');
        if (unreadIndex == -1){
          latestData.data.tags.push('Unread');
        }
      }else if (oldPost && oldPost.length > 0 && oldPost[0].tags){
        const unreadIndex = latestData.data.tags.indexOf('Unread');
        if (unreadIndex != -1){
          latestData.data.tags.splice(unreadIndex, 1);
        }
      }
      if (data[latestData.data.post_type].length > 0) {
        data[latestData.data.post_type].unshift(latestData.data);
        data[latestData.data.post_type] = _.uniqBy(data[latestData.data.post_type], 'id');
      }
      /*update userReaction*/
      if (oldPost.length > 0) {
        data.userReaction = oldPost[0].userReaction;
      }
      data.all.unshift(latestData.data);
      data.all = _.uniqBy(data.all, 'id');
      this.cacheMap.set(companyId, data);
    }
  }

  removeItemFromCache(companyId, item){
    const data = this.cacheMap.get(companyId);
    if (data && data[item.data.post_type]){
      _.remove(data[item.data.post_type], {id: item.data.id});
      _.remove(data.all, {id: item.data.id});

    }
  }

  removeCache(){
    // this.cacheMap=null;
    this.cacheMap = new Map();
  }

  clearCompanyCache(companyId){
    this.cacheMap.delete(companyId);
  }

  insertStoreCache(conversationId, msgObj) {
    this.storeMap.set(conversationId, msgObj);
  }

  removeStoreCache(conversationId) {
    this.storeMap.delete(conversationId);
  }

}
